export default __webpack_public_path__ + "pattern-circle.png?d6431119ff46fbcbd8dc490309da9696";